var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import * as moment from "moment";
import Cover from "../Components/Cover.vue";
import GeneralInformation from "./GeneralInformation.vue";
import Rates from "./Rates.vue";
import Schedule from "./Schedule.vue";
import ChildrensProgram from "./ChildrensProgram.vue";
import WhatIsColloquium from "./WhatIsColloquium.vue";
import { SideNav, SideNavPage } from "../Components/SideNav.ts";
import NavItem from "bootstrap-vue/es/components/nav/nav-item";
import AlertList from "../Components/AlertList.vue";
import Register from "../Components/Register.vue";
var Colloquium = /** @class */ (function (_super) {
    __extends(Colloquium, _super);
    function Colloquium() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Colloquium.prototype, "colloquium", {
        get: function () {
            return __assign({}, this.$props, { travelInformation: __assign({}, this.$props.travelInformation, { arrivalDate: parseDate(this.$props.travelInformation && this.$props.travelInformation.arrivalDate), departureDate: parseDate(this.$props.travelInformation && this.$props.travelInformation.departureDate) }), housing: __assign({}, this.$props.housing, { startDate: parseDate(this.$props.housing && this.$props.housing.startDate), endDate: parseDate(this.$props.housing && this.$props.housing.endDate), rates: parseRates(this.$props.housing && this.$props.housing.rates) }), tuition: __assign({}, this.$props.tuition, { startDate: parseDate(this.$props.tuition && this.$props.tuition.startDate), endDate: parseDate(this.$props.tuition && this.$props.tuition.endDate), rates: parseRates(this.$props.tuition && this.$props.tuition.rates) }), sessions: this.$props.sessions && __assign({}, this.$props.sessions, { children: parseSessions(this.$props.sessions.children) }), extraCurricular: this.$props.extraCurricular && __assign({}, this.$props.extraCurricular, { children: parseSessions(this.$props.extraCurricular.children) }), childrensProgram: this.$props.childrensProgram && __assign({}, this.$props.childrensProgram, { rates: parseRates(this.$props.childrensProgram && this.$props.childrensProgram.rates), children: parseSessions(this.$props.childrensProgram.children) }), startDate: parseDate(this.$props.startDate), endDate: parseDate(this.$props.endDate) });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Colloquium.prototype, "hasLocation", {
        get: function () {
            return this.colloquium.location && this.colloquium.location.title
                ? true
                : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Colloquium.prototype, "hasDates", {
        get: function () {
            return this.colloquium.startDate && this.colloquium.endDate
                ? true
                : false;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, default: "dddd, LL" })
    ], Colloquium.prototype, "dateFormat", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "general", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "location", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "locationLinks", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "nearby", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "banner", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "socialMedia", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "information", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "travelInformation", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "coordinators", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "housing", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "tuition", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "startDate", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "endDate", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "sessions", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "extraCurricular", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "childrensProgram", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "generalEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "generalPhoneNumber", void 0);
    __decorate([
        Prop({ type: Object })
    ], Colloquium.prototype, "colloquia", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "testimonials", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Colloquium.prototype, "resources", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Colloquium.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "registrationUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Colloquium.prototype, "registered", void 0);
    __decorate([
        Prop({ type: String })
    ], Colloquium.prototype, "registrationStart", void 0);
    Colloquium = __decorate([
        Component({
            name: "Colloquium",
            components: {
                "b-nav-item": NavItem,
                Cover: Cover,
                GeneralInformation: GeneralInformation,
                Rates: Rates,
                Schedule: Schedule,
                ChildrensProgram: ChildrensProgram,
                WhatIsColloquium: WhatIsColloquium,
                SideNav: SideNav,
                SideNavPage: SideNavPage,
                AlertList: AlertList,
                Register: Register
            }
        })
    ], Colloquium);
    return Colloquium;
}(Vue));
export default Colloquium;
;
function parseSessions(value) {
    if (!value)
        return [];
    return value
        .map(function (session) {
        return __assign({}, session, { schedule: (session.schedule || [])
                .map(function (schedule) {
                return __assign({}, schedule, { start: parseDate(schedule.start), end: parseDate(schedule.end), rates: parseRates(schedule.rates) });
            }) });
    });
}
function parseDate(value) {
    return value
        ? moment(value)
        : undefined;
}
function parseRates(rates) {
    if (!rates)
        return [];
    return rates
        .map(function (p) { return parseRate(p); });
}
function parseRate(rate) {
    if (rate.type === "date") {
        return __assign({}, rate, { start: parseDate(rate.start), end: parseDate(rate.end) });
    }
    return rate;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Colloquium/Colloquium.vue
// module id = 888
// module chunks = 0